import React from "react"
import Typography from "aldoo-ra/Typography"
import Icon from "aldoo-ra/Icon"
import TextBundle from "aldoo-ra/CMS/text-bundle"

// ---------------------------------------------------------------------------
// Testimonials
// ---------------------------------------------------------------------------
// Built inside the component (not module-level) since quote/name/role come
// from the CMS texts bundle.
function getTestimonials(texts) {
  return [
    {
      quote: texts?.testimonial_1_quote,
      name: texts?.testimonial_1_name,
      role: texts?.testimonial_1_role,
      avatarClass: "from-primary to-secondary",
      shadowColor: "primary",
    },
    {
      quote: texts?.testimonial_2_quote,
      name: texts?.testimonial_2_name,
      role: texts?.testimonial_2_role,
      avatarClass: "from-secondary/70 to-accent/80",
      shadowColor: "secondary",
    },
    {
      quote: texts?.testimonial_3_quote,
      name: texts?.testimonial_3_name,
      role: texts?.testimonial_3_role,
      avatarClass: "from-accent/70 to-primary/70",
      shadowColor: "accent",
    },
  ]
}

function TestimonialAvatar({ name, avatarClass }) {
  const initials = (name || "")
    .split(" ")
    .map((part) => part.charAt(0))
    .join("")
    .replace(".", "")
  return (
    <div
      className={`w-11 h-11 rounded-full bg-gradient-to-br ${avatarClass} flex items-center justify-center text-white font-semibold shrink-0`}
      aria-hidden="true"
    >
      {initials}
    </div>
  )
}

export default function TestimonialsSection() {
  const texts = TextBundle({ id: "home_testimonials_section" })
  const testimonials = getTestimonials(texts)

  return (
    <section className="bg-gradient-to-tl from-primary/10 via-secondary/15 to-secondary/30 rounded-[30px] md:rounded-[50px] lg:rounded-[70px] xl:rounded-[100px] mx-4">
      <div className="max-w-7xl mx-auto px-4 py-20 md:py-28">
        <div className="text-center mb-14">
          <Typography
            component="h2"
            variant="h1"
          >
            {texts?.section_title}
          </Typography>
        </div>

        <div className="grid md:grid-cols-3 gap-3 md:gap-4 xl:gap-6">
          {testimonials.map((testimonial) => (
            <figure
              key={testimonial.name}
              className="flex flex-col gap-4 bg-paper rounded-2xl p-6 shadow-none transition-shadow duration-300 hover:shadow-[0_0_20px_0_var(--card-sc)]"
              style={{ "--card-sc": `rgb(var(--color-${testimonial.shadowColor}) / 0.5)` }}
            >
              <Icon
                id="quotation_mark"
                recolor={true}
                className="w-8 text-accent/50"
              />
              <Typography
                variant="body1"
                className="leading-relaxed"
              >
                {testimonial.quote}
              </Typography>

              <figcaption className="mt-auto flex items-center gap-3">
                <TestimonialAvatar name={testimonial.name} avatarClass={testimonial.avatarClass} />

                <div>
                  <Typography
                    variant="h4"
                    className="font-semibold text-text"
                  >
                    {testimonial.name}
                  </Typography>

                  <Typography variant="txt_dim">
                    {testimonial.role}
                  </Typography>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
